import shopifyGenericDefaults from '../shopify-generic/config.js';

window.Convermax.hideFacetPanel = (e) => {
  const hideFiltersButton = e.target;

  if (hideFiltersButton) {
    hideFiltersButton.classList.toggle('is-expanded');
  }

  const facetPanel = window.document.querySelector('.cm_FacetPanel');

  if (facetPanel) {
    facetPanel.classList.toggle('cm_hide');
  }

  const mainContent = window.document.querySelector('.cm_main-content');

  if (mainContent) {
    mainContent.classList.toggle('cm_max-width');
  }
};

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  SearchRequestDefaults: {
    pageSize: 35,
  },
  pagination: {
    centralRange: 1,
    edgeRange: 1,
  },
};
